import { api } from "./api";

// Login de PACIENTE direto no /Patient/login (sem a popup de agendamento, que caía no /loginSecretary).
// A cuidado-digital-api responde 404 quando a credencial é inválida.
export interface LoginResult {
  token: string;
  userName?: string;
  userId?: number;
}

export async function loginPaciente(login: string, password: string): Promise<LoginResult> {
  const { data } = await api.post("/Patient/login", { email: login, password });
  const token = data?.token ?? data?.data?.token ?? data?.accessToken;
  const userName = data?.userName ?? data?.data?.userName ?? data?.name;
  const userId = data?.userId ?? data?.data?.userId ?? data?.id;
  if (!token) throw new Error("Não foi possível entrar. Tente novamente.");
  return { token, userName, userId };
}

// ---- Recuperação de senha (WhatsApp / Email) ----
// Busca os contatos mascarados (telefone + email) SEM enviar código.
export async function recuperarContatos(emailOrCpf: string): Promise<{ email: string | null; phone: string | null }> {
  const { data } = await api.post("/Auth/recovery", { emailOrCpf });
  return { email: data?.email ?? null, phone: data?.phone ?? null };
}
export const recuperarEnviar = (emailOrCpf: string, metodo: "whatsapp" | "email" = "whatsapp") =>
  api.post(`/Auth/recoveryBy${metodo === "email" ? "Email" : "WhatsApp"}`, { emailOrCpf });

export const recuperarValidar = (code: string, emailOrCpf: string) =>
  api.post("/Auth/recoverycodevalidate", { code, emailOrCpf });

export const recuperarSenha = (code: string, emailOrCpf: string, newPassword: string) =>
  api.post("/Auth/passwordReset", { code, emailOrCpf, newPassword });

// Extrai a mensagem de erro dos formatos da cuidado-digital-api:
//  404 no login = credencial inválida ; { "Code": ["Codigo inválido!"] } ; { errors: {...} } ; { message }.
export function mensagemErro(err: any, fallback = "Não foi possível concluir. Tente novamente."): string {
  const status = err?.response?.status;
  const d = err?.response?.data;
  if (status === 404) return "CPF/e-mail ou senha inválidos.";
  if (typeof d === "string" && d.trim()) return d;
  if (d?.message) return d.message;
  const buscar = (o: any): string | null => {
    if (!o || typeof o !== "object") return null;
    for (const v of Object.values(o)) {
      if (Array.isArray(v) && v.length && typeof v[0] === "string") return v[0] as string;
      if (typeof v === "string") return v;
    }
    return null;
  };
  return buscar(d?.errors) ?? buscar(d) ?? fallback;
}
